import { Component, Input } from "@angular/core";

import { ErrorType } from "@tylertech/shared-module";

@Component({
    selector: "error-page",
    templateUrl: "./errorPage.tmpl.html",
    styleUrls: [
        "./errorPage.component.scss",
    ],
    standalone: false
})
export class ErrorPageComponent
{
    @Input() readonly errorType: ErrorType = ErrorType.ServerError;
    @Input() readonly header: string;
    @Input() readonly message: string;

    get errorHeader(): string
    {
        if (!this.header)
        {
            switch (this.errorType)
            {
                case ErrorType.NotFound:
                    return "Nothing but tumbleweeds here...";
                case ErrorType.NoPermission:
                    return "Sorry, we can't let you in here.";
                case ErrorType.ServerError:
                default:
                    return "Oops, something went wrong!";
            }
        }
        else
        {
            return this.header;
        }
    }

    get errorMessage(): string
    {
        if (!this.message)
        {
            switch (this.errorType)
            {
                case ErrorType.NotFound:
                    return "Even our best explorer couldn't find the page you're looking for. It might have been removed or you may have mistyped the URL.";
                case ErrorType.NoPermission:
                    return "You don't have the security clearance to view this page. Contact your system administrator for access.";
                case ErrorType.ServerError:
                default:
                    return "An internal error occurred. We suggest you pull over and contact your system administrator.";
            }
        }
        else
        {
            return this.message;
        }
    }

    get isServerError(): boolean
    {
        return this.errorType === ErrorType.ServerError || this.errorType === undefined;
    }

    get isNotFoundError(): boolean
    {
        return this.errorType === ErrorType.NotFound;
    }

    get isPermissionError(): boolean
    {
        return this.errorType === ErrorType.NoPermission;
    }
}
